export const EMBED_IFRAME_ALLOW =
  "autoplay; fullscreen; encrypted-media; picture-in-picture; clipboard-write";
